module.exports = __webpack_public_path__ + "media/images/scorecard-reminder-4142e48d1d9342a4e8f9fe8194805117.png";